import { post } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { z } from "zod";

const requestSchema = z.object({
  email: z.string(),
  requesterUrl: z.string(),
});

const responseSchema = z.object({
  loginLink: z.string(),
});

export type MintAdminMagicLinkParams = z.infer<typeof requestSchema>;
export type MintAdminMagicLinkResult = z.infer<typeof responseSchema>;

export function useMintAdminMagicLink(
  options?: UseMutationOptions<MintAdminMagicLinkResult, unknown, MintAdminMagicLinkParams>
): UseMutationResult<MintAdminMagicLinkResult, unknown, MintAdminMagicLinkParams> {
  return useMutation({
    mutationKey: ["mint-admin-magic-link"],
    mutationFn: async (params) => {
      const response = await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/auth/admin/magic-link`,
        data: params,
        bodySchema: requestSchema,
        responseSchema,
      });
      return response.data;
    },
    retry: false,
    meta: { logErrorMessage: APP_V2_APP_EVENTS.MINT_ADMIN_MAGIC_LINK_FAILURE },
    ...options,
  });
}
